module.exports = __webpack_public_path__ + "static/img/xcx_qrcode.c1227fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xcx_qrcode.jpg
// module id = atiP
// module chunks = 0